export default {"src":"/_next/static/media/errorPage404.c4f9296d.svg","height":158,"width":400,"blurWidth":0,"blurHeight":0};